/*eslint-disable */
import { Field as Fieldmik, Form as Formiker, withFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Dropdown, Form as FormUi, TextArea,Icon } from 'semantic-ui-react';
import * as yup from 'yup';
import {
  errorAlertDispatcher, successAlertDispatcher
} from '../../redux/actions/alertAction';
import { AllRegex } from '../../utils/validation';
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED, REQUIRED_FIELDS } from '../../utils/validationConstant';
import CreateAxios from '../axiosComponent/create';
import ReadAxios from '../axiosComponent/read';
import UpdateAxios from '../axiosComponent/update';
import MyCustomerType from '../dynamicComponent/myCustomertype';
import cogoToast from "cogo-toast";
import UploadFile from '../dynamicComponent/Upload';
import { LOCAL_STORAGE } from '../../utils/constant';

const customerNumber = localStorage.getItem('customerNumber')

const InsertBranches = ({
  values,
  setFieldValue,
  t,
  touched,
  title,
  errors,
  handleSubmit,
  editData,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [customertype, setcustomertype] = useState([]);
  const [industryName, setindustryName] = useState([]);
  const [isloading, setLoading] = useState(false);


  var vendorIndex = 0;

  useEffect(() => {
    getCustomerType();
    getIndustry();

  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
    // if (values.vendor) handleSubmit();
  };

  const mappedBillingParty = (content, data) => {
    let temp = {}
    let arr = []

    if (data) {
      let paid = '0'
      let freeOfCost = '0'
      let toPay = '0'
      let toBeBilled = '0'

      data.value.map((object) => {
        if (object === 'paid') {
          paid = '1'
        } else if (object === 'freeOfCost') {
          freeOfCost = '1'
        } else if (object === 'toPay') {
          toPay = '1'
        } else if (object === 'toBeBilled') {
          toBeBilled = '1'
        }

      })
      if (data.value.length > 0) {
        content['paid'] = paid
        content['freeOfCost'] = freeOfCost
        content['toPay'] = toPay
        content['toBeBilled'] = toBeBilled
        // arr.push(temp)

        UpdateAxios({
          completeURL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping`, payload: content,
        }).then((response) => {
          console.log(response);
        })
      }
    }

  }

  const getItReturnUrlImage = (imageKey) => {
    const userId = LOCAL_STORAGE.userId;
    const token = LOCAL_STORAGE.userToken;
    const customerNo = LOCAL_STORAGE.customerNo;
    return `${process.env.REACT_APP_MASTER_API}/getBillingPartyDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
  }

  const getFile = (imageKey) => {
    const userId = LOCAL_STORAGE.userId;
    const token = LOCAL_STORAGE.userToken;
    const customerNo = LOCAL_STORAGE.customerNo;
    const url = `${process.env.REACT_APP_MASTER_API}/getBillingPartyDocument?authorization=${token}&keyName=${imageKey}&customerNumber=${customerNo}&userId=${userId}`
    window.open(url, '_blank').focus();
  }

  const isImageFile = (key) => {
    let image_ext = ["jpeg", "jpg", "png"]
    let key_arr = key && key.split(".")
    let key_ext = key_arr && key_arr.length && key_arr[key_arr.length - 1]
    if(key_ext && image_ext.includes(key_ext)) return true;
    else return false;
  }

  const handleSubmited = () => {
    if (
      // values.billingPartyCode && 
      values.billingPartyName &&
      values.billingPartyAddress && values.billingPartyContactPersonNumber && values.billingPartyAddress && values.billingPartyPincodeNo) {
      handleSubmit();
      setmodalOpen(false);
    } else {
      handleSubmit();
    }
  };

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/billingPartyPaymentType`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getIndustry = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API}/industry_segment`,
    })
      .then((res) => {
        // this.props.create(temShipment);
        setLoading(false);
        let industry = res.data.resultSet;
        setindustryName(
          industry.map((item, index) => {
            return {
              key: index,
              value: item.industrySegmentId,
              text: item.industrySegmentName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <React.Fragment>
      <div className='ui form'>
        <Formiker>
          <div className='container-fluid animated slideInDown pad w3-white'>
            <div className='m-3 pl-3'>
              <div className='ui form'>
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('billingPartyCode.title') || 'Consignee Code'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    className='display-grid-center-imp'
                    width={4}
                    error={
                      touched.billingPartyCode && errors.billingPartyCode ? true : false
                    }
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyCode'
                      placeholder={t('billingPartyCode.placeholder') || 'Code'}
                      //   disabled={editData.billingPartyCode ? true : false}
                      value={values.billingPartyCode}
                    />
                    {/* {customerNumber != 1379 && touched.billingPartyCode && errors.billingPartyCode ? (
                      <div>
                        {t(`billingPartyCode.error_msg.${errors.billingPartyCode}`) ||
                          errors.billingPartyCode}
                      </div>
                    ) : null} */}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('billingPartyName.title') || 'Billing Part Name'} <span className='red'>*</span>
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={
                      touched.billingPartyName && errors.billingPartyName ? true : false
                    }
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyName'
                      // value={editData.billingPartyName}
                      placeholder={t('billingPartyName.placeholder') || 'Name'}
                    />
                    {touched.billingPartyName && errors.billingPartyName ? (
                      <div className='error-msg'>
                        {errors.billingPartyName}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group >
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('email.title') || 'Email Id'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    className='display-grid-center-imp'
                    width={4}
                    error={touched.billingPartyEmail && errors.billingPartyEmail ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyEmail'
                      // value={editData.billingPartyEmail}
                      placeholder={t('email.placeholder') || 'Email Id'}
                    />
                    {/* <Checkbox label={t('billingPartyEmail_id.action.title') || 'Alerts'} /> */}
                    {touched.billingPartyEmail && errors.billingPartyEmail ? (
                      <div className='error-msg'>
                        {errors.billingPartyEmail}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('billingPartyContactPersonNumber.title') || 'Mobile No.'}
                    </label>
                  </FormUi.Field>


                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyContactPersonNumber'
                      placeholder={t('billingPartyContactPersonNumber.placeholder') || 'Mobile No.'}
                    />
                    {touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? (
                      <div className='error-msg'>
                        {t(`${errors.billingPartyContactPersonNumber}`) || errors.billingPartyContactPersonNumber}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>

                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('address.title') || 'Address'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.billingPartyAddress && errors.billingPartyAddress ? true : false}
                  >
                    <Fieldmik
                      as={TextArea}
                      className='ui input'
                      name='billingPartyAddress'
                      // value={editData.billingPartyAddress}
                      placeholder={
                        t('address.placeholder') || 'Company Address'
                      }
                    />
                    {touched.billingPartyAddress && errors.billingPartyAddress ? (
                      <div className='error-msg'>
                        {errors.billingPartyAddress}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('pincode.title') || 'Billing Party Pincode'}
                    </label>
                  </FormUi.Field>

                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyPincodeNo'
                      placeholder={t('pincode.placeholder') || 'Pin code'}
                    />
                    {touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? (
                      <div className='error-msg'>
                        {errors.billingPartyPincodeNo}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('customer_type_id.title') || 'customer_type_id'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.customer_type_id && errors.customer_type_id
                        ? true
                        : false
                    }
                  >
                    <Fieldmik
                      type='text'
                      // className='ui input'
                      multiple
                      name='customer_type_id'
                      placeholder='Select'
                      value={values.customer_type_id}
                      multiSelect={true}
                      editId={editData.billingPartyId}
                      mode={title}
                      component={MyCustomerType}
                      mappedBillingParty={mappedBillingParty}
                    />
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('industry.title') || 'industry'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.industrySegmentId && errors.industrySegmentId
                        ? true
                        : false
                    }
                  >
                    <Dropdown
                      clearable
                      style={{ width: '100%', fontWeight: 'normal' }}
                      search
                      selection
                      name='industrySegmentId'
                      value={values.industrySegmentId}
                      placeholder={
                        t('industry.placeholder') ||
                        'Industry'
                      }
                      onChange={(name, data) =>
                        setFieldValue(`industrySegmentId`, data.value)
                      }
                      options={industryName}
                    />
                    {touched.industrySegmentId && errors.industrySegmentId ? (
                      <div className='error-msg'>
                        {errors.industrySegmentId}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('creditPeriod.title') || 'Credit Period'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={touched.creditPeriod && errors.creditPeriod ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='creditPeriod'
                      placeholder={t('creditPeriod.placeholder') || 'Credit Period'}
                    />
                    {touched.creditPeriod && errors.creditPeriod ? (
                      <div className='error-msg'>
                        {t(`${errors.creditPeriod}`) || errors.creditPeriod}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2} />
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('billingPartyContactPerson.title') || 'Credit Period'}<span className='red'>*</span>
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={touched.billingPartyContactPerson && errors.billingPartyContactPerson ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='billingPartyContactPerson'
                      placeholder={t('billingPartyContactPerson.placeholder') || 'Contact Person'}
                    />
                    {touched.billingPartyContactPerson && errors.billingPartyContactPerson ? (
                      <div className='error-msg'>
                        {errors.billingPartyContactPerson}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>

                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className='labelName'>
                      {t('panNumber.title') || 'PAN Number'}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className='display-grid-center-imp'
                    error={touched.panNumber && errors.panNumber ? true : false}
                  >
                    <Fieldmik
                      type='text'
                      className='ui input'
                      name='panNumber'
                      placeholder={t('panNumber.placeholder') || 'PAN Number'}
                    />
                    {touched.panNumber && errors.panNumber ? (
                      <div className='error-msg'>
                        {t(`${errors.panNumber}`) || errors.panNumber}
                      </div>
                    ) : null}
                  </FormUi.Field>

                  <FormUi.Field width={2} />
                  <FormUi.Field width={2}>
                    <label>{t("panDoc.title"||"Pan Document")}</label>
                  </FormUi.Field>
                  <FormUi.Field width={4}>
                    <Fieldmik
                      name="panCardPath"
                      style={{ width: "23%" }}
                      buttonName={
                        values.panCardPath
                          ? "File Selected"
                          : "Choose File"
                      }
                      className="w3-button w3-round w3-small w3-border w3-hover-blue"
                      typer={["pdf", "jpeg", "jpg", "png"]}
                      values={values}
                      component={UploadFile}
                      upload_url={`masters/addBillingPartyDocument`}
                    />
                    {values?.panCardPath && isImageFile(values?.panCardPath) ?
                      <a href={getItReturnUrlImage(values?.panCardPath)} target="_blank">
                        <img src={getItReturnUrlImage(values?.panCardPath)} style={{ height: 60, width: 60 }} />
                      </a> :
                      <Button
                        onClick={() => getFile(values?.panCardPath)}
                        basic
                        size="mini"
                        type="button"
                        icon
                      >
                        <Icon name="eye" color="blue" />
                      </Button>
                    }
                  </FormUi.Field>
                </FormUi.Group>
              </div>
            </div>
          </div>
        </Formiker >
        <center>
          <Button
            type='submit'
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size='mini'
            className='w3-blue w3-round w3-hover-blue'
          >
            {t('action_button.submit') || 'Submit'}
          </Button>
        </center>
      </div>
    </React.Fragment >
  )
};

const FormikBranches = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    creditPeriod: yup.string().optional().nullable().matches(AllRegex.PositiveNumberWithPoint, INVALID_FIELDS.INVALID_NUMBER),
    billingPartyAddress: yup.string().optional().nullable().matches(AllRegex.Address, INVALID_FIELDS.INVALID_ADDRESS),
    billingPartyPincodeNo: yup.string().optional().nullable().matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE),
    billingPartyEmail: yup.string().optional().nullable().matches(AllRegex.Email, INVALID_FIELDS.INVALID_EMAIL),
    billingPartyContactPersonNumber: yup.string().optional().nullable().matches(AllRegex.MobileNumber, INVALID_FIELDS.INVALID_MOBILE_NO),
    billingPartyName: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED),
    billingPartyContactPerson: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.Name, INVALID_FIELDS.INVALID_NAME),
    panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_FIELDS.INVALID_PAN_NUMBER).nullable(),
  }),
  mapPropsToValues: (props) => {
    return {
      billingPartyCode: props?.editData?.billingPartyCode || '',
      billingPartyName: props?.editData?.billingPartyName || '',
      billingPartyAddress: props?.editData?.billingPartyAddress || '',
      billingPartyEmail: props?.editData?.billingPartyEmail || '',
      billingPartyContactPersonNumber: props?.editData?.billingPartyContactPersonNumber || '',
      billingPartyContactPerson: props?.editData?.billingPartyContactPerson || '',
      creditPeriod: props?.editData?.creditPeriod || '',
      billingPartyPincodeNo: props?.editData?.billingPartyPincodeNo || '',
      customer_type_id: props?.editData?.customer_type_id || [],
      industrySegmentId: props?.editData?.industrySegmentId || '',
      panNumber: props?.editData?.panNumber || '',
      panCardPath: props?.editData?.panCardPath || '',
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    if (props.title == 'edit') {
      if (values.customer_type_id.length > 0) {
        values.customer_type_id.map((element) => {
          values[element] = '1'
        })
      }
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_MASTER_API}/billing_party/${props.editData.billingPartyId}`,
        payload: { ...values },
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.status === 204) {
              cogoToast.error(res.data.message);
            }
            else {
              setSubmitting(false);
              props.successAlertDispatcher({
                type: 'success',
                messageHeader: 'Success',
                messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
              });
              cogoToast.success('Billing Party Created');
              props.onFormSubmit();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: 'error',
            messageHeader: 'Error',
            messageBody: err.data ? err.data.message : err.message,
          });
        });
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_MASTER_API}/billing_party_type_mapping/test`,
        payload: { ...values, billingPartyId: editData.billingPartyId },
      })
        .then((res) => {
          setSubmitting(false);
          props.successAlertDispatcher({
            type: 'success',
            messageHeader: 'Success',
            messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
          });
          props.onFormSubmit();
          // props.reFetchConsignee();
          // setmodalOpen(false);
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: 'error',
            messageHeader: 'Error',
            messageBody: err.data ? err.data.message : err.message,
          });
        });


    } else {
      if (values.customer_type_id.length > 0) {
        values.customer_type_id.map((element) => {
          values[element] = '1'
        })
      }
      CreateAxios({
        url: 'billing_party',
        payload: { ...values },
      })
        .then((res) => {

          if (res.status === 200) {
            if (res.data.status === 204) {
              cogoToast.error(res.data.message);
            }
            else {
              setSubmitting(false);
              props.successAlertDispatcher({
                type: 'success',
                messageHeader: 'Success',
                messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
              });
              cogoToast.success('Billing Party Created');
              props.onFormSubmit();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: 'error',
            messageHeader: 'Error',
            messageBody: err.data ? err.data.message : err.message,
          });
        });
    }
  },
})(InsertBranches);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate('create_billing_party')(FormikBranches)
);
